module.exports = __webpack_public_path__ + "fonts/baronsans-romanitalic-webfont.ce3486de.woff";